import React from 'react';
import PropTypes from 'prop-types';

import CancellationReason from 'components/account/Order/CancellationReason';
import OrderProduct from 'components/account/Order/OrderProduct';
import css from 'styles/components/account/cancelOrderListLayout.scss';

const CancelOrderListLayout = ({ lineItems, cancellationReasons, onCancellationReasonChange, isCancellationConfirmed }) => (
  <div>
    {lineItems.map((lineItem, index) => {
      const { amount, product } = lineItem;
      return (
        <div key={index} className={css.orderProduct}>
          <OrderProduct product={product} price={amount}/>
          {!isCancellationConfirmed &&
              <div className={css.cancellationReason}>
                <CancellationReason
                  index={index}
                  lineItem={lineItem}
                  cancellationReasons={cancellationReasons}
                  onCancellationReasonChange={onCancellationReasonChange}/>
              </div>
          }
        </div>
      );
    })}
  </div>
);

CancelOrderListLayout.contextTypes = {
  testId: PropTypes.func
};

CancelOrderListLayout.propTypes = {
  lineItems: PropTypes.array.isRequired,
  cancellationReasons: PropTypes.array.isRequired,
  isCancellationConfirmed: PropTypes.bool,
  onCancellationReasonChange: PropTypes.func.isRequired
};

export default CancelOrderListLayout;
